import React, { useMemo } from 'react'
import { CustomCellRendererProps } from 'ag-grid-react'
import { DefaultCellContentWrapper, TypedValueGetterParams } from 'view/components/datagrid'
import { Tooltip } from 'view/components/tooltip'
import { InflightNegotiations } from 'api'
import { inflightNegotiationsRowDataGetter } from './utils'
import { getNegotiationsBreakdown } from './getNegotiationsBreakdown'

export const CellContentWithNegotiationsInfo = (props: CustomCellRendererProps<InflightNegotiations>) => {
  const negotiations = inflightNegotiationsRowDataGetter(props as TypedValueGetterParams<InflightNegotiations>)

  const tooltipInfo = useMemo(() => getNegotiationsBreakdown(negotiations, props.context.userPreference), [
    negotiations,
    props.context.userPreference
  ])

  return (
    <Tooltip tooltip={tooltipInfo}>
      <DefaultCellContentWrapper>{props?.valueFormatted ?? props?.value ?? ''}</DefaultCellContentWrapper>
    </Tooltip>
  )
}
